import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type VoicemailMessageQueryVariables = Types.Exact<{
  voicemailId: Types.Scalars['Int']['input'];
  userId: Types.Scalars['Int']['input'];
}>;


export type VoicemailMessageQuery = { __typename?: 'Query', voicemailMessage?: string | null };

export type CallListQueryVariables = Types.Exact<{
  domainId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  interval?: Types.InputMaybe<Types.CallListInterval>;
  numberId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  filterValue?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type CallListQuery = { __typename?: 'Query', callList: { __typename?: 'CallList', calls: Array<{ __typename?: 'Call', callId: string, callTime: any, onBehalfOf?: string | null, connectTime: any, disconnectTime: any, connected: boolean, direction: string, duration: number, private: boolean, remoteE164: string, remoteNumber: string, remoteNumberId?: number | null, localNumber: string, localDomain: string, localE164: string, localNumberId?: number | null, originalCallingNumber?: string | null, originalCallingE164?: string | null, segmentType: Types.SegmentType, recordingId?: string | null, disconnectReason?: Types.DisconnectReason | null, recordingStore?: Types.RecordingStore | null, thirdPartyNumber?: string | null }> } };

export type NumberListQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type NumberListQuery = { __typename?: 'Query', users?: { __typename?: 'UserList', items: Array<{ __typename?: 'User', displayName: string, numberId: number, number?: { __typename?: 'Number', shortNumber?: string | null } | null } | null> } | null, groups?: { __typename?: 'GroupList', items: Array<{ __typename?: 'Group', name: string, numberId: number, number?: { __typename?: 'Number', shortNumber?: string | null, e164?: any | null } | null } | null> } | null, ivrs?: { __typename?: 'IvrList', items: Array<{ __typename?: 'Ivr', name: string, numberId: number, number?: { __typename?: 'Number', shortNumber?: string | null, e164?: any | null } | null } | null> } | null };


export const VoicemailMessageDocument = gql`
    query VoicemailMessage($voicemailId: Int!, $userId: Int!) {
  voicemailMessage(voicemailId: $voicemailId, userId: $userId)
}
    `;

/**
 * __useVoicemailMessageQuery__
 *
 * To run a query within a React component, call `useVoicemailMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useVoicemailMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVoicemailMessageQuery({
 *   variables: {
 *      voicemailId: // value for 'voicemailId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useVoicemailMessageQuery(baseOptions: Apollo.QueryHookOptions<VoicemailMessageQuery, VoicemailMessageQueryVariables> & ({ variables: VoicemailMessageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VoicemailMessageQuery, VoicemailMessageQueryVariables>(VoicemailMessageDocument, options);
      }
export function useVoicemailMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VoicemailMessageQuery, VoicemailMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VoicemailMessageQuery, VoicemailMessageQueryVariables>(VoicemailMessageDocument, options);
        }
export function useVoicemailMessageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VoicemailMessageQuery, VoicemailMessageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VoicemailMessageQuery, VoicemailMessageQueryVariables>(VoicemailMessageDocument, options);
        }
export type VoicemailMessageQueryHookResult = ReturnType<typeof useVoicemailMessageQuery>;
export type VoicemailMessageLazyQueryHookResult = ReturnType<typeof useVoicemailMessageLazyQuery>;
export type VoicemailMessageSuspenseQueryHookResult = ReturnType<typeof useVoicemailMessageSuspenseQuery>;
export type VoicemailMessageQueryResult = Apollo.QueryResult<VoicemailMessageQuery, VoicemailMessageQueryVariables>;
export const CallListDocument = gql`
    query CallList($domainId: Int, $interval: CallListInterval, $numberId: Int, $filterValue: String) {
  callList(
    domainId: $domainId
    interval: $interval
    numberId: $numberId
    filterValue: $filterValue
  ) {
    calls {
      callId
      callTime
      onBehalfOf
      connectTime
      disconnectTime
      connected
      direction
      duration
      private
      remoteE164
      remoteNumber
      remoteNumberId
      localNumber
      localDomain
      localE164
      localNumberId
      originalCallingNumber
      originalCallingE164
      segmentType
      recordingId
      disconnectReason
      recordingStore
      thirdPartyNumber
    }
  }
}
    `;

/**
 * __useCallListQuery__
 *
 * To run a query within a React component, call `useCallListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCallListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCallListQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *      interval: // value for 'interval'
 *      numberId: // value for 'numberId'
 *      filterValue: // value for 'filterValue'
 *   },
 * });
 */
export function useCallListQuery(baseOptions?: Apollo.QueryHookOptions<CallListQuery, CallListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CallListQuery, CallListQueryVariables>(CallListDocument, options);
      }
export function useCallListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CallListQuery, CallListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CallListQuery, CallListQueryVariables>(CallListDocument, options);
        }
export function useCallListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CallListQuery, CallListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CallListQuery, CallListQueryVariables>(CallListDocument, options);
        }
export type CallListQueryHookResult = ReturnType<typeof useCallListQuery>;
export type CallListLazyQueryHookResult = ReturnType<typeof useCallListLazyQuery>;
export type CallListSuspenseQueryHookResult = ReturnType<typeof useCallListSuspenseQuery>;
export type CallListQueryResult = Apollo.QueryResult<CallListQuery, CallListQueryVariables>;
export const NumberListDocument = gql`
    query NumberList($domainId: Int!) {
  users(domainId: $domainId) {
    items {
      displayName
      numberId
      number {
        shortNumber
      }
    }
  }
  groups(domainId: $domainId) {
    items {
      name
      numberId
      number {
        shortNumber
        e164
      }
    }
  }
  ivrs(domainId: $domainId) {
    items {
      name
      numberId
      number {
        shortNumber
        e164
      }
    }
  }
}
    `;

/**
 * __useNumberListQuery__
 *
 * To run a query within a React component, call `useNumberListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNumberListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNumberListQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useNumberListQuery(baseOptions: Apollo.QueryHookOptions<NumberListQuery, NumberListQueryVariables> & ({ variables: NumberListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NumberListQuery, NumberListQueryVariables>(NumberListDocument, options);
      }
export function useNumberListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NumberListQuery, NumberListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NumberListQuery, NumberListQueryVariables>(NumberListDocument, options);
        }
export function useNumberListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NumberListQuery, NumberListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NumberListQuery, NumberListQueryVariables>(NumberListDocument, options);
        }
export type NumberListQueryHookResult = ReturnType<typeof useNumberListQuery>;
export type NumberListLazyQueryHookResult = ReturnType<typeof useNumberListLazyQuery>;
export type NumberListSuspenseQueryHookResult = ReturnType<typeof useNumberListSuspenseQuery>;
export type NumberListQueryResult = Apollo.QueryResult<NumberListQuery, NumberListQueryVariables>;